<template>
  <div
    class="intent-item pa-0 mb-3"
    :style="{
      border: `1px solid ${$vuetify.theme.primary}`,
      width: '100%'
    }"
    :class="{ edit: isEdit }"
    @click="isExpanded = !isExpanded"
  >
    <v-layout wrap class="pa-2">
      <v-flex xs9>
        <h3 class="primary--text">{{ job.name_th }}</h3>
        <h4 class="grey--text">{{ job.name_en }}</h4>
      </v-flex>
      <v-flex xs3 style="display: flex; justify-content: flex-end; align-items: center">
        <toggle-button
          :value="job.active"
          :sync="true"
          :color="$vuetify.theme.success"
          :labels="{ checked: 'ON', unchecked: 'OFF' }"
          style="display: inline-block"
          @change="handleChangeIsActive(job)"
        />
        <v-btn icon outline color="primary" small @click.stop="isEdit = true">
          <em class="fas fa-pencil-alt"></em>
        </v-btn>
        <v-btn
          icon
          outline
          color="primary"
          small
          @click.stop="handleDeleteBangkokbankJobInterests(job)"
        >
          <em class="fa fa-trash"></em>
        </v-btn>
      </v-flex>
    </v-layout>

    <v-layout wrap align-center class="pa-2">
      <v-flex xs9>
        <div>
          <span>{{ $t('bbl.job_vacancy') }}</span>
          <span class="px-1">{{ job.bangkokbank_job_interests.length }}</span>
          <span>{{ $t('position') }}</span>
        </div>
      </v-flex>
      <v-flex xs3 style="display: flex; justify-content: flex-end">
        <span
          class="fas pr-2"
          :style="`font-size: 1.5em; cursor: pointer; color: ${$vuetify.theme.primary}`"
          :class="{ 'fa-chevron-down': !isExpanded, 'fa-chevron-up': isExpanded }"
        ></span>
      </v-flex>
    </v-layout>

    <div v-if="isExpanded" class="px-3 pb-2">
      <div v-if="job.bangkokbank_job_interests && job.bangkokbank_job_interests.length > 0">
        <ul style="list-style-type: disc; padding-left: 12px">
          <template v-for="sJob in job.bangkokbank_job_interests">
            <li :key="sJob.id">
              {{ sJob.name_th }} ({{ sJob.name_en }})
              <span v-if="sJob.zone && sJob.zone.length > 0"> [{{ sJob.zone.join(', ') }}] </span>
            </li>
          </template>
        </ul>
      </div>
    </div>

    <JobManageFormDialog
      v-if="isEdit"
      :dialog-open="isEdit"
      form-type="edit"
      :edit-data="job"
      @onCloseDialog="isEdit = false"
      @onSaveSuccess="handleSaveSuccess"
    />
  </div>
</template>

<script>
import JobManageFormDialog from './JobManageFormDialog.vue'
import bangkokbankApi from '@/api/bangkokbank.js'
import { ToggleButton } from 'vue-js-toggle-button'
import { mapGetters } from 'vuex'

export default {
  components: {
    JobManageFormDialog,
    ToggleButton
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      job: this.item,
      isEdit: false,
      isExpanded: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  watch: {
    item: {
      deep: true,
      handler() {
        this.job = this.item
      }
    }
  },
  mounted() {
    this.job = this.item
  },
  methods: {
    async handleDeleteBangkokbankJobInterests(job) {
      const vm = this
      try {
        if (!job) {
          throw 'No job id'
        }

        const result = await vm.$swal.fire({
          title: vm.$t('Do you want to delete {name}?', {
            name: job.name_th
          }),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        if (result.value) {
          vm.$store.dispatch('loading')
          const response = await bangkokbankApi.deleteBangkokbankJobInterests(
            job.id,
            vm.selectedBot.pageid
          )
          if (response && response.status === 204) {
            vm.$store.commit('CLEAR_LOADING')

            vm.$swal({
              title: vm.$t('deleted successfully'),
              type: 'success',
              confirmButtonText: vm.$t('Confirm')
            })
            this.$emit('onRefetchList')
          }
        }
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        console.error(error)
        await vm.$swal({
          title: vm.$t('an error occurred please try again'),
          type: 'error',
          text: `${error.message}`,
          confirmButtonText: vm.$t('Confirm')
        })
      }
    },
    async handleChangeIsActive(job) {
      const vm = this
      try {
        if (!job) {
          throw 'No job id'
        }

        const result = await vm.$swal.fire({
          title: vm.$t(
            job.active ? 'Do you want to is inactive {name}?' : 'Do you want to is active {name}?',
            {
              name: job.name_th
            }
          ),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        if (result.value) {
          let params = {
            ...job,
            active: !job.active
          }
          vm.$store.dispatch('loading')
          const response = await bangkokbankApi.updateBangkokbankJobInterestIsActive(params)
          if (response && response.status === 204) {
            vm.$store.commit('CLEAR_LOADING')

            vm.$swal({
              title: vm.$t('updated successfully'),
              type: 'success',
              confirmButtonText: vm.$t('Confirm')
            })
            this.$emit('onRefetchList')
          }
        }
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        console.error(error)
        await vm.$swal({
          title: vm.$t('an error occurred please try again'),
          type: 'error',
          text: `${error.message}`,
          confirmButtonText: vm.$t('Confirm')
        })
      }
    },
    handleSaveSuccess() {
      this.isEdit = false
      this.$emit('onRefetchList')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/bblcareer/Job/JobItem.vue